import { RowData } from "@tanstack/react-table";
import clsx from "clsx";

import { IRydeRow, RenderSubComponentModel } from "@ryde/shared";

import { GridTableCell } from "./grid.table.cell";
import { GridTableDetailsPanel } from "./grid.table.details-panel";

export interface IGridRowPropsReport<T extends RowData> {
  row: IRydeRow<T>;
  renderSubComponent?: RenderSubComponentModel<T>;
}

export const GridRowReport = <T extends RowData>({
  row,
  renderSubComponent,
}: IGridRowPropsReport<T>): JSX.Element => {
  return (
    <>
      <tr
        data-e2e="table-row"
        className={clsx({
          expanded: row.getIsExpanded(),
        })}
      >
        {row.getVisibleCells().map(cell => (
          <GridTableCell<T> key={cell.id} cell={cell} />
        ))}
      </tr>
      {renderSubComponent && (
        <GridTableDetailsPanel
          row={row}
          renderSubComponent={renderSubComponent}
        />
      )}
    </>
  );
};
